import Cookies from 'js-cookie'
/**
 * Created by jiachenpan on 16/11/18.
 */
// 兼容IOS5以上版本
import { getCookie } from './auth'

export function newDate(date) {
  var d = new Date(date)
  return d.getFullYear() > 0 ? d : new Date(Date.parse(date.replace(/-/g, '/')))
}
// 转换时间格式 yyyy-mm-dd hh-mm-ss
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xdc00 && code <= 0xdfff) i--
  }
  return s
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
       giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @description: 防抖函数
 * @param {type} func 要防抖的函数
 * @param {type} wait 防抖间隔
 * @param {type} immediate 是否立即出发，最好为false
 * @return:
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result
  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    console.log('timeout', timeout)
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}


 /**
     *
     * 时间格式化
     * @param {number|string|Date} d 时间参数 数字，字符串，日期类型
     * @param {string} fmt 时间格式参数 字符串类型 默认'yyyy/MM/dd'
     */
 export function formatDate (d, fmt) {
    if (fmt === void 0) { fmt = 'yyyy/MM/dd'; }
    if (!d) {
        return false;
    }
    var date = typeof d === 'number' ?
        new Date((d < 10000000000 && d > -10000000000) ? d * 1000 : d) : typeof d === 'string' ? new Date(d.replace(/-/ig, '/')) : d,
        o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
            'q+': Math.floor((date.getMonth() + 3) / 3),
            'S': date.getMilliseconds() //毫秒
        };
    if (/(y+)/i.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear().toString()).substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")", 'i').test(fmt)) {
            var str = o[k].toString();
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ("0" + str).substr(str.length - 1));
        }
    }
    return fmt;
};

/****
 * 防抖
 * ***/
export function debounce1 (fn, delay, immediate)  {
    let timer;
    return function(args) {
        const that = this,
            _args = args
        if (timer) clearTimeout(timer)
        if (immediate) {
            let callNow = !timer;
            timer = setTimeout(() => {
                timer = null
            }, delay);
            if (callNow) fn.call(that, _args)
        } else {
            timer = setTimeout(() => {
                fn.call(that, _args)
            }, delay)
        }
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

// todo 处理字典空数据
export function handleEmptyData(data) {
  return data === 0 || data === -1 ? '' : data
}
// todo 处理字典
// 格式2： [ {id: '2', name: '盒'}]
export function handleArrDict(dict, value) {
  for (let i = 0; i < dict.length; i++) {
    if (dict[i].id === value) {
      return dict[i].name
    }
  }
}
// todo 处理脏数据
export function handleDictId(dict, obj) {
  let id = ''
  for (let i = 0; i < dict.length; i++) {
    if (dict[i].name === obj.name || dict[i].id === obj.id) {
      id = dict[i].id
    }
  }
  return id
}

// todo 去掉空格
export function Trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
// todo 缓存数据
export function setStorageByKey(key, data = '') {
  window.localStorage.setItem(key, data)
}

export function getStorageByKey(key) {
  return window.localStorage.getItem(key) || ''
}

export function removeStorageByKey(key) {
  return window.localStorage.removeItem(key)
}
// 计算年龄
export function jsGetAge(strBirthday) {
  var returnAge
  var strBirthdayArr = strBirthday.split('-')
  var birthYear = strBirthdayArr[0]
  var birthMonth = strBirthdayArr[1]
  var birthDay = strBirthdayArr[2]
  var d = new Date()
  var nowYear = d.getFullYear()
  var nowMonth = d.getMonth() + 1
  var nowDay = d.getDate()

  if (nowYear === birthYear) {
    returnAge = 0 // 同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        var monthDiff = nowMonth - birthMonth // 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = -1 // 返回-1 表示出生日期输入错误 晚于今天
    }
  }

  return returnAge // 返回周岁年龄
}
// 获取当前月份的第一天
export function getCurrentMonthFirst(date) {
  date.setDate(1)
  var month = parseInt(date.getMonth() + 1)
  var day = date.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day
}
// 获取当前月份的最后一天
export function getCurrentMonthLast(date) {
  var currentMonth = date.getMonth()
  var nextMonth = ++currentMonth
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  var oneDay = 1000 * 60 * 60 * 24
  var lastTime = new Date(nextMonthFirstDay - oneDay)
  var month = parseInt(lastTime.getMonth() + 1)
  var day = lastTime.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return new Date(date.getFullYear() + '-' + month + '-' + day)
}

/**
 * 简单函数节流
 * @param action 要节流的函数
 * @param delay 节流时间间隔
 * @returns {Function}
 */
export function throttle(action, delay) {
  let last = 0
  return function() {
    const current = Number(new Date())
    if (current - last > delay) {
      action.apply(this, arguments)
      last = current
    }
  }
}

// 下划线转换驼峰
export function lineToHump(str) {
  return str.replace(/\_(\w)/g, function(all, letter) {
    return letter.toUpperCase()
  })
}

// 驼峰转换下划线
export function humpToLine(str) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 获取距离当前日期 n天的日期  格式为 'y-m-d'
export function getDateStrAfter(AddDayCount) {
  const dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount)
  const y = dd.getFullYear()
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
  const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
  return y + '-' + m + '-' + d
}

// export function accDiv(arg1,arg2){
//   var t1=0,t2=0,r1,r2;
//   try{
//     t1=arg1.toString().split(".")[1].length}catch(e){}
//     try{
//       t2=arg2.toString().split(".")[1].length}catch(e){}
//       with(Math){
//       r1=Number(arg1.toString().replace(".",""))
//       r2=Number(arg2.toString().replace(".",""))
//       return accMul((r1/r2),pow(10,t2-t1));
//     }
//   }  /* 何问起 hovertree.com */

// 精确小数点 乘法
export function getAccuracyMultiplication(arg1, arg2) {
  let m = 0
  let s1
  let s2
  if (arg1 !== null || arg1 !== undefined) {
    s1 = arg1.toString()
    s2 = arg2.toString()
  } else {
    s1 = arg1
    s2 = arg2
  }

  try {
    m += s1.split('.')[1].length
  } catch (e) {
    m = 0
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
    m = 0
  }
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}
// 精确小数点 加法
export function getAccuracyAdd(arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}
// 精确小数点 减法
export function getAccuracySubtraction(arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  const n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

function addZero(num) {
  return num < 10 ? '0' + num : num
}

// 转换时间格式 yyyy-mm-dd
export function parseDate(timestamp) {
  var date = new Date(timestamp)
  var year = date.getFullYear()
  var month = addZero(date.getMonth() + 1)
  var day = addZero(date.getDate())
  // var hours = addZero(date.getHours())
  // var minutes = addZero(date.getMinutes())
  // var seconds = addZero(date.getSeconds())
  // return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return year + '-' + month + '-' + day
}

// 判断日期 是否在当前日期的前后n年以内
export function isDateBetweenYears(dateStr, year) {
  dateStr = dateStr.replace(new RegExp('-', 'gm'), '/')
  const dateString = new Date(dateStr).getTime()
  let flag = false
  const startDateString = new Date().setFullYear(
    new Date().getFullYear() - year
  )
  const endDateString = new Date().setFullYear(new Date().getFullYear() + year)
  const startFlag = dateString > startDateString
  const endFlag = dateString < endDateString
  if (startFlag && endFlag) {
    flag = true
  }
  return flag
}

// 判断日期是否在 1900-9999范围之内
export function isDateBetween(dateStr, startDateStr, endDateStr) {
  dateStr = dateStr.replace(new RegExp('-', 'gm'), '/')
  const dateString = new Date(dateStr).getTime()
  let flag = false
  const startDateString = new Date(startDateStr).getTime()
  const endDateString = new Date(endDateStr).getTime()
  const startFlag = dateString >= startDateString
  const endFlag = dateString <= endDateString
  if (startFlag && endFlag) {
    flag = true
  }
  return flag
}

/**
 *  y-m-d 转化为时间戳
 *
 * @param {*} date
 * @returns
 */
export function dateToDate(date) {
  let sDate = new Date()
  if (typeof date === 'object' && typeof new Date().getMonth === 'function') {
    sDate = date
  } else if (typeof date === 'string') {
    const arr = date.split('-')
    if (arr.length === 3) {
      sDate = new Date(arr[0] + '-' + arr[1] + '-' + arr[2])
    }
  }
  return sDate
}

/**
 *   根据月数 加减日期
 * @param {*} date 日期
 * @param {*} num  月数
 * @param {*} flag 加减标识
 * @returns
 */
export function resetMonth(date, num, flag) {
  num = parseInt(num)
  const sDate = dateToDate(date)
  const sYear = sDate.getFullYear()
  const sMonth = sDate.getMonth() + 1
  const sDay = sDate.getDate()
  let eYear = sYear
  let eMonth = flag === 'add' ? sMonth + num : sMonth - num
  let eDay = sDay

  if (flag === 'add' && eMonth > 12) {
    eYear++
    eMonth -= 12
  }
  if (flag === 'reduce' && eMonth < 0) {
    eYear--
  }

  let eDate = new Date(eYear, eMonth - 1, eDay)
  if (eDate.getMonth() !== eMonth - 1) {
    eDay--
    eDate = new Date(eYear, eMonth - 1, eDay)
  }
  return (
    eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()
  )
}
/**
 * 判断版本工具函数
 * @param {*} ver1
 * @param {*} ver2
 */
export function versionFunegt(ver1, ver2) {
  const version1pre = parseFloat(ver1)
  const version2pre = parseFloat(ver2)
  const version1next = ver1.replace(version1pre + '.', '')
  const version2next = ver2.replace(version2pre + '.', '')
  if (version1pre > version2pre) {
    return true
  } else if (version1pre < version2pre) {
    return false
  } else {
    if (version1next >= version2next) {
      return true
    } else {
      return false
    }
  }
}
/**
 * @msg: 判断当前是否是Ios
 * @param {type}
 * @return: true or false
 */
export function getIsIos() {
  const client = getCookie('native_client')
  if (client === 'ios') {
    return true
  }
}
/**
 * @msg: 判断当前是否是android
 * @param {type}
 * @return: true or false
 */
export function getIsAndroid() {
  const client = getCookie('native_client')
  if (client === 'android' || client === 'pad') {
    return true
  }
}


export function getIOSVersion() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // 检测是否为 iOS 设备
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  if (!isIOS) {
    return null;
  }

  // 从 userAgent 中提取 iOS 版本
  let iOSVersion = userAgent.match(/OS (\d+_\d+(_\d+)?)/);
  if (iOSVersion && iOSVersion.length > 1) {
    iOSVersion = iOSVersion[1].replace(/_/g, '.');
  } else {
    iOSVersion = 'unknown';
  }

  return {
    iOSVersion: iOSVersion,
    majorVersion: parseInt(iOSVersion.split('.')[0], 10)
  };
}


/**
 * @description: 初始化性能日志参数
 * @param {Object}
 * @return: void
 */
export function initLog({ message, type = 'info' }) {
  const osType = Cookies.get("native_client") || ""
  const appVersion = Cookies.get("native_version") || ""
  const userId = Cookies.get('native_organSign') || ""
  const drugstoreName = Cookies.get('native_drugstoreName') || ""
  const pageId = Cookies.get('pageId') || ""
  const timestamp = +new Date()
  const time = parseTime(timestamp)
  return {
    timestamp,
    time,
    userId,
    drugstoreName,
    message: `${pageId},${time}：${message}`,
    type,
    osType,
    appVersion
  }
}

/**
 * 三级等保
 */
export function getInsuranceImage(url) {
  if(!url)return url;
  const RegEx = /(.JPEG|.jpeg|.JPG|.jpg|.png|.PNG|.pdf|.PDF|.zip|.ZIP).*/;
  if(url.match(RegEx)){
    const matches = (url.match(RegEx))[0];
    var insuranceImage = (url.replace(matches,''));
    insuranceImage = insuranceImage.substring(0,insuranceImage.length - 3);
    console.log("三级等保++++++",url,"++++++",insuranceImage + matches);
    return insuranceImage + matches;
  }else{
    return url;
  }
}